
  import React from "react"
  import Component from "C:/Users/User/Documents/bh0-gatsby-blog/src/layouts/index.js"
  import data from "C:\\Users\\User\\Documents\\bh0-gatsby-blog\\.cache\\json\\layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js